import { render, staticRenderFns } from "./CardPostpaid.vue?vue&type=template&id=0e25115e&scoped=true&"
import script from "./CardPostpaid.vue?vue&type=script&lang=js&"
export * from "./CardPostpaid.vue?vue&type=script&lang=js&"
import style0 from "./CardPostpaid.vue?vue&type=style&index=0&id=0e25115e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e25115e",
  null
  
)

export default component.exports